<main class="fadeIn">
  <div class="container-fluid" #focusedElement>
    <div class="row">
      <div class="col-12">
        <div class="header d-flex justify-content-between">
          <h1>Custom Validation</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="filter-body">
          <div class="filter">
            <div class="row">
              <div class="col-10">
                <div class="row" [formGroup]="customVaidationFilterForm">
                  <div class="col-4">
                    <input type="text" class="form-control " id="preSender" placeholder="Validation"
                      formControlName="validation" appPreventFirstSpace>
                  </div>
                  <div class="col-2 d-flex">
                    <button id="btnGroupApply" type="button" class="btn btn-dark-blue"
                      (click)="getCustomValidationList()"
                      [ngClass]="{'disabled':customVaidationFilterForm.invalid}">APPLY</button>
                    <a class="reset-btn" (click)="resetFilter()"><span></span>Reset</a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="table-container table-responsive">
          <table class="table table-list cs-val">
            <caption class="d-none">Provider list table body</caption>
            <thead>
              <tr>
                <th scope="col">Validation Id
                  <span *ngIf="customValidationList.length" class="sort-order"
                    (click)="sortColumn('requestValidationId')">
                    <a class="{{columnSort['requestValidationId'].sortType}} "></a>
                  </span>
                </th>
                <th scope="col">Validation
                  <span *ngIf="customValidationList.length" class="sort-order" (click)="sortColumn('validation')">
                    <a class="{{columnSort['validation'].sortType}} "></a>
                  </span>
                </th>
                <th scope="col"> EXECUTION ORDER
                  <span *ngIf="customValidationList.length" class="sort-order" (click)="sortColumn('executionOrder')">
                    <a class="{{columnSort['executionOrder'].sortType}} "></a>
                  </span>
                </th>
                <th scope="col" style="width: 130px;">
                </th>
              </tr>
            </thead>
            <tbody *ngIf="customValidationList.length">
              <tr *ngFor="let validtions of customValidationList;let i=index;">
                <td>{{validtions.requestValidationId | notEmpty}}</td>
                <td>{{validtions.validation | notEmpty}}</td>
                <td>{{validtions.executionOrder | notEmpty}}</td>
                <td>
                  <div class="toggle-switch-type-two" *ngIf="checkPermission('editValidationStatus')">
                    <input id="toggle" class="toggle-input-type-two" checked="" type="checkbox"
                      [(ngModel)]="customValidationList[i].isActive" (click)="confirmUpdate(i)">
                    <label for="toggle"
                      class="toggle-label-type-two"><span>{{setStatusValue(validtions.isActive)}}</span></label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="no-data with-border" *ngIf="!customValidationList.length">
          <img src="./assets/images/icons/no-data-img.svg" alt="">
          <p>No Results Found</p>
        </div>
        <app-navigation *ngIf="!showNavigation" [listLength]="totalCount" [pageNo]="page_no"
          (currentPageDetail)="currentPageDetail($event)">
        </app-navigation>
      </div>
    </div>
  </div>
</main>
